import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORY_META_PARAM } from './onboardingAnalytics';

const META: Meta = {
  description: 'Event sent when a user views the onboarding invite members step',
  name: 'viewed_onboarding_invite_members',
  params: [ONBOARDING_ANALYTICS_CATEGORY_META_PARAM],
};

export default META;
